var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.996,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.998 16a8 8 0 118-8 8.009 8.009 0 01-8 8zm0-6.586l1.766 1.764a1.001 1.001 0 001.416-1.416L9.413 7.996l1.767-1.768a1.001 1.001 0 00-1.416-1.416L7.997 6.58 6.23 4.812a1.001 1.001 0 00-1.416 1.416l1.767 1.768-1.767 1.766a1.001 1.001 0 001.416 1.416l1.766-1.764z",
    fill: "#8e8e95"
  })));
}
export default SvgRemoveError;